import React from 'react';
import { VerifiedBadge } from './VerifiedBadge';
import { VerificationStatus, KYCOverallStatus, PublicVerificationBadges, Profile } from '../../types';

interface VerificationBadgeProps {
  profile?: Profile | any;
  status?: VerificationStatus;
  kycStatus?: KYCOverallStatus;
  badges?: PublicVerificationBadges;
  isProfilePhotoVerified?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  interactivePopover?: boolean;
  variant?: 'pill' | 'icon_only' | 'detailed' | 'banner';
  className?: string;
}

export const VerificationBadge: React.FC<VerificationBadgeProps> = ({
  profile,
  status = 'pending',
  kycStatus,
  badges,
  isProfilePhotoVerified,
  size = 'md',
  showLabel = true,
  interactivePopover = true,
  variant = 'pill',
  className = '',
}) => {
  return (
    <VerifiedBadge
      profile={profile}
      status={status}
      kycStatus={kycStatus}
      badges={badges}
      isProfilePhotoVerified={isProfilePhotoVerified}
      size={size}
      showLabel={showLabel}
      interactivePopover={interactivePopover}
      variant={variant}
      className={className}
    />
  );
};

export { VerifiedBadge };
